import { lazy } from 'react';

const UserManagementPage = lazy(() => import('./UserManagementPage'));

const UserManagementAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/settings/user-management',
			element: <UserManagementPage />
		}
	]
};
export default UserManagementAppConfig;
